import Link from 'next/link';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface ItemLegalsProps {
  copyright: boolean;
}

export const ContainerBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'center',
    textAlign: 'center',
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'space-between',
    textAlign: 'left',
  },
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('xs')]: {
    alignItems: 'center',
  },
  [theme.breakpoints.up('md')]: {
    alignItems: 'start',
  },
}));

export const IconMedia = styled('img')(({ theme }) => ({
  width: 40,
  height: 40,
  [theme.breakpoints.down('md')]: {
    maxWidth: 'none',
  },
}));

export const StackMedia = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: '2rem 0',
  gap: '1rem',
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'center',
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'left',
  },
}));

export const StackLinks = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '2rem',
  [theme.breakpoints.only('sm')]: {
    flexWrap: 'wrap',
    margin: '0 auto',
    textAlign: 'left',
    width: '50%',
    paddingLeft: '1.5rem',
    gap: '2rem',
  },
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    textAlign: 'left',
    paddingLeft: '0.5rem',
    gap: '2rem',
  },
}));

export const StackLinksSuperDuper = styled(Stack)(({ theme }) => ({
  gap: '0.5rem',
  width: '25%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    width: '40%',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '0.8rem 2rem',
    marginBottom: '2rem',
    '&& a': {
      width: '40%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    gap: '1rem 2rem',
  },
}));

export const StackList = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  alignItems: 'start',
  [theme.breakpoints.down('md')]: {
    marginBottom: '2rem',
    width: '40%',
  },
}));

export const BoxRights = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',
  marginTop: '2rem',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    marginTop: '1rem',
    flexDirection: 'column',
  },
}));

export const StackItemRights = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1.5rem',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: '50%',
    margin: '0 auto',
  },
}));

export const LinkLegals = styled(Link)(({ theme }) => ({
  color: 'inherit',
  ...theme.typography.body2,
  [theme.breakpoints.down('md')]: {
    width: '40%',
  },

  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const BusinessName = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.secondary.dark,
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const ItemLegals = styled(Typography)<ItemLegalsProps>(({ theme, copyright }) => ({
  ...theme.typography.body2,
  color: theme.palette.secondary.dark,
  ...(copyright
    ? {
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
          textAlign: 'center',
        },
      }
    : {
        paddingBottom: '2vh',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
          textAlign: 'left',
        },
      }),
}));

export const TextModalContain = styled(Box)(({ theme }) => ({
  width: '80%',
  margin: '5vh auto 10vh',
  textAlign: 'start',
  '&& p': {
    margin: '2rem 0 2rem ',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '5vh auto 8vh',
  },
}));

export const Line = styled('li')(({ left }: { left: string }) => ({
  marginLeft: left,
  marginBottom: '0.8rem',
  '&::marker': {
    color: '#83c634',
  },
}));

export const GridNoPadding = styled(Grid)(() => ({
  paddingLeft: '0 !important',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.2rem',
}));

export const SeasonalContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'center',
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),

  height: 48,
  fontSize: '0.85rem',
  fontWeight: 400,
  '& a': {
    color: theme.palette.primary.contrastText,
  },
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    fontSize: '0.75rem',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));
